<template>
  <div :class="classModifier">
    <div :class="menuClassModifier">
      <div class="market-filters-mobile__menu-order">
        <menu-button
          @click="toggleOrder"
          :type="selectedOrder.sort"
          :theme="theme"
          :name="orderMenuName"
          :active="ordersOpen"
          :arrow="true"
        ></menu-button>
      </div>
      <div v-if="shouldShowTimespanFilter" class="market-filters-mobile__menu-timespans">
        <menu-button
          @click="toggleTimespans"
          type="timespan"
          :theme="theme"
          :name="selectedTimespan.name"
          :active="timespansOpen"
          :arrow="true"
        ></menu-button>
      </div>
      <div class="market-filters-mobile__menu-filters">
        <menu-button
          @click="toggleFilters"
          type="filters"
          :theme="theme"
          :name="filterMenuName"
          :active="filtersOpen"
          :arrow="true"
        ></menu-button>
      </div>
    </div>
    <transition name="slide-down">
      <div class="market-filters-mobile__order" v-if="ordersOpen">
        <menu-button
          v-for="order in orderList('markets')"
          :theme="theme"
          :key="order.sort"
          :type="order.sort"
          :name="order.fullName"
          :selected="orderSelected(order.sort)"
          @click="selectOrderAndClose"
        ></menu-button>
      </div>
    </transition>
    <transition name="slide-down">
      <div class="market-filters-mobile__filters" v-if="filtersOpen">
        <a class="market-filters-mobile__clear-all" @click.prevent="onClearFilters"
          >Clear Selections</a
        >
        <div class="market-filters-mobile__filters-group" v-for="category in filters">
          <h3>{{ category.name }}</h3>
          <filter-button
            v-for="filter in category.filters"
            :theme="theme"
            :key="filterKey(filter)"
            :id="filter.filterId"
            :name="filter.name"
            :selected="filterSelected(filter.filterId)"
            @addFilter="onAddFilter"
            @removeFilter="onRemoveFilter"
          ></filter-button>
        </div>
      </div>
    </transition>
    <transition name="slide-down">
      <div class="market-filters-mobile__timespans" v-if="timespansOpen">
        <menu-button
          v-for="timespan in availableTimespanOptions"
          :theme="theme"
          :key="timespan.parameter"
          :type="timespan.parameter"
          :name="timespan.name"
          @click="selectTimespanAndClose"
        ></menu-button>
      </div>
    </transition>
  </div>
</template>

<script src="./market-filters-mobile.js"></script>
<style src="./market-filters-mobile.scss" lang="scss"></style>
